var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 290,
    viewBox: "0 0 375 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_1_331)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M377.472 106.296V78.975H361.25V106.296H342.04V64.0338H327.952V32.4438H316.426V0H292.52V32.4438H280.994V64.0338H267.334V26.0404H259.65V6.83027H254.954V26.0404H227.633V147.278H206.715V134.471H193.908V147.278H172.99V106.296H135.424V78.975H119.202V106.296H118.348V158.804H101.273V128.068H80.7818V158.804H63.7061V64.0338H50.4724V32.4438H1.80676V64.0338H-11V230.949H63.7061H118.348H172.99H227.633H267.334H342.04H396.682V106.296H377.472Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0405 73.8523H-2.88892V84.0977H15.0405V73.8523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.239 84.0977H55.1685V73.8522H37.239V84.0977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0405 93.9163H-2.88892V104.162H15.0405V93.9163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.239 104.162H55.1685V93.9162H37.239V104.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0405 113.98H-2.88892V124.226H15.0405V113.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.239 124.226H55.1685V113.98H37.239V124.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0405 134.044H-2.88892V144.289H15.0405V134.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.239 144.29H55.1685V134.044H37.239V144.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0405 154.108H-2.88892V164.353H15.0405V154.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.239 164.353H55.1685V154.108H37.239V164.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0405 174.172H-2.88892V184.417H15.0405V174.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.239 184.417H55.1685V174.172H37.239V184.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0405 194.236H-2.88892V204.481H15.0405V194.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.239 204.481H55.1685V194.236H37.239V204.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.945 169.049H70.1096V174.172H111.945V169.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.945 176.733H70.1096V181.856H111.945V176.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.945 184.417H70.1096V189.54H111.945V184.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M221.229 171.611H179.394V176.733H221.229V171.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M221.229 179.295H179.394V184.417H221.229V179.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M221.229 186.979H179.394V192.101H221.229V186.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.945 192.101H70.1096V197.224H111.945V192.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.945 199.785H70.1096V204.908H111.945V199.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111.945 207.469H70.1096V212.592H111.945V207.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.839 116.115H127.313V131.056H138.839V116.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.5 131.056H164.026V116.115H152.5V131.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.839 140.021H127.313V154.962H138.839V140.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.5 154.962H164.026V140.021H152.5V154.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.839 163.927H127.313V178.868H138.839V163.927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.5 178.868H164.026V163.927H152.5V178.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.839 187.833H127.313V202.774H138.839V187.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.5 202.774H164.026V187.832H152.5V202.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.001 35.8589H227.633V55.4959H243.001V35.8589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.001 64.0338H227.633V83.6708H243.001V64.0338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.001 92.2086H227.633V111.846H243.001V92.2086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.001 120.384H227.633V140.021H243.001V120.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.001 148.558H227.633V168.195H243.001V148.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.001 176.733H227.633V196.37H243.001V176.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M333.288 75.9868H276.085V92.6356H333.288V75.9868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M333.502 111.846H276.298V128.494H333.502V111.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M333.715 147.705H276.512V164.353H333.715V147.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M333.929 183.563H276.725V200.212H333.929V183.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.49094 41.4086H1.80688V57.6305H9.49094V41.4086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2038 204.716C10.2038 204.716 -23.4054 224.993 38.5494 256.212C38.5494 256.212 52.21 230.872 37.1065 210.21C34.1773 206.183 29.8726 203.37 25.0081 202.303C20.1435 201.237 15.0569 201.993 10.7118 204.426L10.2038 204.716Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5923 204.289C10.5923 204.289 39.352 226.295 38.5494 256.212",
    stroke: "#535461",
    strokeWidth: 0.426892,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1118 257.365C40.1118 257.365 29.5803 221.608 42.0883 195.29C47.3391 184.247 49.0808 171.845 46.656 159.858C45.4966 154.167 43.8176 148.594 41.64 143.209",
    stroke: "#535461",
    strokeWidth: 0.853784,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4052 126.599C49.4052 130.983 41.4693 143.675 41.4693 143.675C41.4693 143.675 33.5334 130.966 33.5334 126.599C33.5089 125.542 33.6959 124.49 34.0836 123.506C34.4713 122.522 35.0518 121.625 35.7909 120.869C36.5301 120.112 37.413 119.511 38.3878 119.101C39.3625 118.691 40.4095 118.479 41.4672 118.479C42.5248 118.479 43.5718 118.691 44.5466 119.101C45.5214 119.511 46.4043 120.112 47.1434 120.869C47.8826 121.625 48.463 122.522 48.8507 123.506C49.2384 124.49 49.4255 125.542 49.401 126.599H49.4052Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5363 150.872C60.1543 154.552 46.5876 160.904 46.5876 160.904C46.5876 160.904 46.8352 145.925 49.2173 142.245C50.3857 140.536 52.1757 139.351 54.2053 138.943C56.235 138.535 58.3436 138.937 60.0814 140.062C61.8192 141.187 63.0486 142.947 63.5072 144.966C63.9658 146.984 63.6174 149.102 62.5363 150.868V150.872Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9603 192.353C58.0457 194.326 43.1301 192.964 43.1301 192.964C43.1301 192.964 50.9038 180.157 54.8184 178.185C56.6915 177.286 58.8421 177.158 60.8086 177.828C62.7751 178.498 64.4005 179.912 65.336 181.766C66.2715 183.621 66.4424 185.769 65.8121 187.748C65.1817 189.728 63.8004 191.381 61.9646 192.353H61.9603Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4595 223.64C50.9377 226.244 36.0007 227.422 36.0007 227.422C36.0007 227.422 41.4991 213.489 45.021 210.88C45.8581 210.251 46.8116 209.793 47.8265 209.534C48.8414 209.274 49.8975 209.218 50.9341 209.369C51.9707 209.52 52.9672 209.875 53.866 210.413C54.7649 210.95 55.5484 211.661 56.1713 212.503C56.7943 213.345 57.2443 214.302 57.4955 215.319C57.7467 216.336 57.7942 217.393 57.635 218.428C57.4759 219.463 57.1134 220.457 56.5683 221.352C56.0233 222.246 55.3066 223.024 54.4595 223.64Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9262 161.754C33.0681 164.806 47.7148 167.969 47.7148 167.969C47.7148 167.969 44.1289 153.425 40.9869 150.368C40.2458 149.613 39.3612 149.014 38.385 148.606C37.4089 148.197 36.3609 147.988 35.3028 147.991C34.2447 147.994 33.1979 148.208 32.2238 148.621C31.2497 149.034 30.3681 149.638 29.6308 150.397C28.8935 151.156 28.3154 152.055 27.9306 153.04C27.5457 154.026 27.3618 155.079 27.3897 156.136C27.4176 157.194 27.6568 158.235 28.0931 159.199C28.5294 160.163 29.1541 161.03 29.9304 161.749L29.9262 161.754Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6188 198.454C25.5334 200.426 40.449 199.064 40.449 199.064C40.449 199.064 32.6753 186.257 28.7607 184.285C26.8876 183.387 24.737 183.259 22.7705 183.928C20.8041 184.598 19.1786 186.012 18.2431 187.867C17.3076 189.721 17.1367 191.869 17.767 193.849C18.3974 195.828 19.7787 197.481 21.6145 198.454H21.6188Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4385 235.235C21.9604 237.839 36.8973 239.017 36.8973 239.017C36.8973 239.017 31.399 225.079 27.8728 222.475C26.1797 221.243 24.0684 220.73 21.9989 221.049C19.9295 221.367 18.0695 222.49 16.8244 224.173C15.5793 225.856 15.0498 227.963 15.3513 230.035C15.6529 232.107 16.761 233.976 18.4343 235.235H18.4385Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M49.4052 126.599C49.4052 130.983 41.4693 143.675 41.4693 143.675C41.4693 143.675 33.5334 130.966 33.5334 126.599C33.5089 125.542 33.6959 124.49 34.0836 123.506C34.4713 122.522 35.0518 121.625 35.7909 120.869C36.5301 120.112 37.413 119.511 38.3878 119.101C39.3625 118.691 40.4095 118.479 41.4672 118.479C42.5248 118.479 43.5718 118.691 44.5466 119.101C45.5214 119.511 46.4043 120.112 47.1434 120.869C47.8826 121.625 48.463 122.522 48.8507 123.506C49.2384 124.49 49.4255 125.542 49.401 126.599H49.4052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M62.5363 150.872C60.1543 154.552 46.5876 160.904 46.5876 160.904C46.5876 160.904 46.8352 145.925 49.2173 142.245C50.3857 140.536 52.1757 139.351 54.2053 138.943C56.235 138.535 58.3436 138.937 60.0814 140.062C61.8192 141.187 63.0486 142.947 63.5072 144.966C63.9658 146.984 63.6174 149.102 62.5363 150.868V150.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M61.9603 192.353C58.0457 194.326 43.1301 192.964 43.1301 192.964C43.1301 192.964 50.9038 180.157 54.8184 178.185C56.6915 177.286 58.8421 177.158 60.8086 177.828C62.7751 178.498 64.4005 179.912 65.336 181.766C66.2715 183.621 66.4424 185.769 65.8121 187.748C65.1817 189.728 63.8004 191.381 61.9646 192.353H61.9603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M54.4595 223.64C50.9377 226.244 36.0007 227.422 36.0007 227.422C36.0007 227.422 41.4991 213.489 45.021 210.88C45.8581 210.251 46.8116 209.793 47.8265 209.534C48.8414 209.274 49.8975 209.218 50.9341 209.369C51.9707 209.52 52.9672 209.875 53.866 210.413C54.7649 210.95 55.5484 211.661 56.1713 212.503C56.7943 213.345 57.2443 214.302 57.4955 215.319C57.7467 216.336 57.7942 217.393 57.635 218.428C57.4759 219.463 57.1134 220.457 56.5683 221.352C56.0233 222.246 55.3066 223.024 54.4595 223.64Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M29.9262 161.754C33.0681 164.806 47.7148 167.969 47.7148 167.969C47.7148 167.969 44.1289 153.425 40.9869 150.368C40.2458 149.613 39.3612 149.014 38.385 148.606C37.4089 148.197 36.3609 147.988 35.3028 147.991C34.2447 147.994 33.1979 148.208 32.2238 148.621C31.2497 149.034 30.3681 149.638 29.6308 150.397C28.8935 151.156 28.3154 152.055 27.9306 153.04C27.5457 154.026 27.3618 155.079 27.3897 156.136C27.4176 157.194 27.6568 158.235 28.0931 159.199C28.5294 160.163 29.1541 161.03 29.9304 161.749L29.9262 161.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M21.6188 198.454C25.5334 200.426 40.449 199.064 40.449 199.064C40.449 199.064 32.6753 186.257 28.7607 184.285C26.8876 183.387 24.737 183.259 22.7705 183.928C20.8041 184.598 19.1786 186.012 18.2431 187.867C17.3076 189.721 17.1367 191.869 17.767 193.849C18.3974 195.828 19.7787 197.481 21.6145 198.454H21.6188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M18.4385 235.235C21.9604 237.839 36.8973 239.017 36.8973 239.017C36.8973 239.017 31.399 225.079 27.8728 222.475C26.1797 221.243 24.0684 220.73 21.9989 221.049C19.9295 221.367 18.0695 222.49 16.8244 224.173C15.5793 225.856 15.0498 227.963 15.3513 230.035C15.6529 232.107 16.761 233.976 18.4343 235.235H18.4385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.84 248.131C368.84 248.131 358.309 212.375 370.817 186.057C376.067 175.013 377.809 162.612 375.384 150.625C374.225 144.933 372.546 139.36 370.368 133.976",
    stroke: "#535461",
    strokeWidth: 0.853784,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.15 117.365C378.15 121.75 370.214 134.441 370.214 134.441C370.214 134.441 362.279 121.733 362.279 117.365C362.254 116.308 362.441 115.256 362.829 114.272C363.216 113.288 363.797 112.392 364.536 111.635C365.275 110.879 366.158 110.278 367.133 109.867C368.108 109.457 369.155 109.245 370.212 109.245C371.27 109.245 372.317 109.457 373.292 109.867C374.266 110.278 375.149 110.879 375.889 111.635C376.628 112.392 377.208 113.288 377.596 114.272C377.984 115.256 378.171 116.308 378.146 117.365H378.15Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.693 183.12C386.778 185.092 371.862 183.73 371.862 183.73C371.862 183.73 379.636 170.923 383.551 168.951C385.424 168.053 387.574 167.925 389.541 168.594C391.507 169.264 393.133 170.678 394.068 172.533C395.004 174.387 395.175 176.535 394.544 178.515C393.914 180.494 392.533 182.147 390.697 183.12H390.693Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.192 214.407C379.67 217.011 364.733 218.189 364.733 218.189C364.733 218.189 370.232 204.255 373.754 201.647C375.447 200.415 377.558 199.902 379.628 200.221C381.697 200.539 383.557 201.662 384.802 203.345C386.047 205.028 386.577 207.135 386.275 209.207C385.974 211.279 384.866 213.148 383.192 214.407Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.654 152.507C361.796 155.559 376.443 158.723 376.443 158.723C376.443 158.723 372.857 144.179 369.715 141.122C368.205 139.655 366.175 138.848 364.07 138.879C361.965 138.909 359.959 139.774 358.492 141.284C357.025 142.794 356.218 144.825 356.249 146.929C356.279 149.034 357.145 151.04 358.654 152.507Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.364 189.22C354.279 191.192 369.194 189.83 369.194 189.83C369.194 189.83 361.421 177.024 357.506 175.051C355.635 174.167 353.492 174.048 351.534 174.721C349.576 175.394 347.959 176.805 347.028 178.654C346.096 180.502 345.923 182.642 346.547 184.616C347.17 186.59 348.54 188.242 350.364 189.22Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.167 226.001C350.689 228.605 365.625 229.783 365.625 229.783C365.625 229.783 360.127 215.849 356.605 213.241C354.912 212.009 352.801 211.497 350.731 211.815C348.662 212.133 346.802 213.256 345.557 214.939C344.312 216.623 343.782 218.73 344.084 220.802C344.385 222.874 345.493 224.742 347.167 226.001Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.335 244.652C321.335 244.652 315.675 225.442 322.398 211.294C325.255 205.381 326.116 198.7 324.853 192.255C324.23 189.201 323.328 186.21 322.159 183.32",
    stroke: "#535461",
    strokeWidth: 0.853784,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.339 174.377C326.339 176.733 322.07 183.559 322.07 183.559C322.07 183.559 317.801 176.729 317.801 174.377C317.801 173.245 318.251 172.159 319.051 171.358C319.852 170.558 320.938 170.108 322.07 170.108C323.202 170.108 324.288 170.558 325.088 171.358C325.889 172.159 326.339 173.245 326.339 174.377Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.386 187.423C332.106 189.399 324.814 192.814 324.814 192.814C324.814 192.814 324.947 184.763 326.227 182.787C326.519 182.289 326.908 181.855 327.372 181.511C327.835 181.168 328.364 180.922 328.925 180.789C329.486 180.655 330.069 180.637 330.637 180.735C331.206 180.833 331.749 181.045 332.233 181.358C332.717 181.672 333.133 182.081 333.455 182.559C333.777 183.038 333.998 183.577 334.106 184.144C334.214 184.711 334.206 185.293 334.082 185.857C333.958 186.421 333.722 186.953 333.386 187.423Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.079 209.711C330.975 210.769 322.958 210.039 322.958 210.039C322.958 210.039 327.137 203.158 329.237 202.099C330.24 201.646 331.379 201.598 332.417 201.964C333.455 202.331 334.311 203.084 334.806 204.067C335.302 205.049 335.399 206.185 335.077 207.238C334.756 208.29 334.04 209.178 333.079 209.715V209.711Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.045 226.526C327.15 227.926 319.124 228.558 319.124 228.558C319.124 228.558 322.078 221.07 323.974 219.67C324.886 219.062 325.997 218.827 327.077 219.016C328.157 219.204 329.123 219.801 329.775 220.682C330.427 221.564 330.715 222.662 330.579 223.75C330.443 224.838 329.894 225.832 329.045 226.526Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.863 193.271C317.57 194.91 325.421 196.614 325.421 196.614C325.421 196.614 323.495 188.797 321.805 187.158C321.41 186.737 320.934 186.4 320.405 186.168C319.876 185.936 319.306 185.813 318.728 185.808C318.151 185.803 317.578 185.915 317.045 186.137C316.512 186.36 316.03 186.688 315.628 187.102C315.225 187.517 314.911 188.008 314.704 188.547C314.497 189.086 314.402 189.662 314.424 190.239C314.446 190.816 314.585 191.383 314.832 191.905C315.079 192.427 315.43 192.893 315.863 193.275V193.271Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.397 212.994C313.502 214.052 321.519 213.322 321.519 213.322C321.519 213.322 317.34 206.441 315.239 205.382C314.236 204.929 313.097 204.881 312.06 205.247C311.022 205.614 310.166 206.367 309.67 207.35C309.175 208.332 309.077 209.468 309.399 210.521C309.721 211.573 310.437 212.46 311.397 212.998V212.994Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.69 232.763C311.585 234.163 319.611 234.795 319.611 234.795C319.611 234.795 316.64 227.303 314.761 225.903C313.849 225.282 312.732 225.039 311.645 225.224C310.557 225.409 309.584 226.008 308.928 226.895C308.272 227.782 307.985 228.888 308.127 229.982C308.269 231.076 308.829 232.073 309.69 232.763Z",
    fill: "#613EEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.99 20.3542H99.0527C99.3305 20.3669 99.608 20.3231 99.8685 20.2255C100.129 20.1279 100.367 19.9785 100.568 19.7864C100.769 19.5943 100.929 19.3634 101.038 19.1077C101.148 18.852 101.204 18.5768 101.204 18.2987C101.204 18.0206 101.148 17.7454 101.038 17.4897C100.929 17.234 100.769 17.0031 100.568 16.811C100.367 16.6189 100.129 16.4695 99.8685 16.3719C99.608 16.2743 99.3305 16.2306 99.0527 16.2432H75.262C74.7331 16.2673 74.2338 16.4944 73.868 16.8773C73.5022 17.2601 73.2981 17.7692 73.2981 18.2987C73.2981 18.8282 73.5022 19.3373 73.868 19.7201C74.2338 20.103 74.7331 20.3301 75.262 20.3542H78.1991C77.9212 20.3415 77.6437 20.3853 77.3833 20.4829C77.1229 20.5805 76.885 20.7298 76.6839 20.922C76.4828 21.1141 76.3228 21.345 76.2135 21.6007C76.1041 21.8564 76.0477 22.1316 76.0477 22.4097C76.0477 22.6878 76.1041 22.963 76.2135 23.2187C76.3228 23.4744 76.4828 23.7053 76.6839 23.8974C76.885 24.0895 77.1229 24.2389 77.3833 24.3365C77.6437 24.434 77.9212 24.4778 78.1991 24.4652H74.0881C73.8103 24.4525 73.5328 24.4963 73.2724 24.5939C73.0119 24.6915 72.774 24.8408 72.5729 25.0329C72.3719 25.225 72.2118 25.4559 72.1025 25.7116C71.9931 25.9673 71.9368 26.2425 71.9368 26.5206C71.9368 26.7987 71.9931 27.074 72.1025 27.3297C72.2118 27.5854 72.3719 27.8162 72.5729 28.0084C72.774 28.2005 73.0119 28.3498 73.2724 28.4474C73.5328 28.545 73.8103 28.5888 74.0881 28.5761H97.8788C98.1566 28.5888 98.4341 28.545 98.6945 28.4474C98.9549 28.3498 99.1928 28.2005 99.3939 28.0084C99.595 27.8162 99.755 27.5854 99.8644 27.3297C99.9737 27.074 100.03 26.7987 100.03 26.5206C100.03 26.2425 99.9737 25.9673 99.8644 25.7116C99.755 25.4559 99.595 25.225 99.3939 25.0329C99.1928 24.8408 98.9549 24.6915 98.6945 24.5939C98.4341 24.4963 98.1566 24.4525 97.8788 24.4652H101.99C102.268 24.4778 102.545 24.434 102.805 24.3365C103.066 24.2389 103.304 24.0895 103.505 23.8974C103.706 23.7053 103.866 23.4744 103.975 23.2187C104.085 22.963 104.141 22.6878 104.141 22.4097C104.141 22.1316 104.085 21.8564 103.975 21.6007C103.866 21.345 103.706 21.1141 103.505 20.922C103.304 20.7298 103.066 20.5805 102.805 20.4829C102.545 20.3853 102.268 20.3415 101.99 20.3542Z",
    fill: "#252223"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M207.005 72.0081H204.068C204.346 72.0208 204.623 71.977 204.884 71.8794C205.144 71.7818 205.382 71.6325 205.583 71.4404C205.784 71.2482 205.944 71.0174 206.054 70.7617C206.163 70.506 206.219 70.2307 206.219 69.9526C206.219 69.6745 206.163 69.3993 206.054 69.1436C205.944 68.8879 205.784 68.657 205.583 68.4649C205.382 68.2728 205.144 68.1235 204.884 68.0259C204.623 67.9283 204.346 67.8845 204.068 67.8972H180.277C179.748 67.9213 179.249 68.1484 178.883 68.5312C178.518 68.914 178.313 69.4231 178.313 69.9526C178.313 70.4821 178.518 70.9913 178.883 71.3741C179.249 71.7569 179.748 71.984 180.277 72.0081H183.214C182.937 71.9955 182.659 72.0393 182.399 72.1368C182.138 72.2344 181.9 72.3838 181.699 72.5759C181.498 72.768 181.338 72.9989 181.229 73.2546C181.119 73.5103 181.063 73.7855 181.063 74.0636C181.063 74.3417 181.119 74.6169 181.229 74.8726C181.338 75.1283 181.498 75.3592 181.699 75.5513C181.9 75.7434 182.138 75.8928 182.399 75.9904C182.659 76.088 182.937 76.1318 183.214 76.1191H179.103C178.826 76.1064 178.548 76.1502 178.288 76.2478C178.027 76.3454 177.789 76.4948 177.588 76.6869C177.387 76.879 177.227 77.1099 177.118 77.3656C177.009 77.6213 176.952 77.8965 176.952 78.1746C176.952 78.4527 177.009 78.7279 177.118 78.9836C177.227 79.2393 177.387 79.4702 177.588 79.6623C177.789 79.8544 178.027 80.0038 178.288 80.1014C178.548 80.199 178.826 80.2427 179.103 80.2301H202.894C203.172 80.2427 203.449 80.199 203.71 80.1014C203.97 80.0038 204.208 79.8544 204.409 79.6623C204.61 79.4702 204.77 79.2393 204.88 78.9836C204.989 78.7279 205.045 78.4527 205.045 78.1746C205.045 77.8965 204.989 77.6213 204.88 77.3656C204.77 77.1099 204.61 76.879 204.409 76.6869C204.208 76.4948 203.97 76.3454 203.71 76.2478C203.449 76.1502 203.172 76.1064 202.894 76.1191H207.005C207.283 76.1318 207.56 76.088 207.821 75.9904C208.081 75.8928 208.319 75.7434 208.52 75.5513C208.721 75.3592 208.881 75.1283 208.991 74.8726C209.1 74.6169 209.156 74.3417 209.156 74.0636C209.156 73.7855 209.1 73.5103 208.991 73.2546C208.881 72.9989 208.721 72.768 208.52 72.5759C208.319 72.3838 208.081 72.2344 207.821 72.1368C207.56 72.0393 207.283 71.9955 207.005 72.0081Z",
    fill: "#252223"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M385.873 4.55927H382.936C383.214 4.57193 383.491 4.52815 383.752 4.43057C384.012 4.33298 384.25 4.18362 384.451 3.9915C384.652 3.79938 384.812 3.5685 384.922 3.3128C385.031 3.0571 385.087 2.78188 385.087 2.50378C385.087 2.22569 385.031 1.95047 384.922 1.69477C384.812 1.43907 384.652 1.20819 384.451 1.01607C384.25 0.823952 384.012 0.674591 383.752 0.577006C383.491 0.47942 383.214 0.435638 382.936 0.448302H359.145C358.616 0.472413 358.117 0.699503 357.751 1.08234C357.386 1.46518 357.181 1.97429 357.181 2.50378C357.181 3.03328 357.386 3.54239 357.751 3.92523C358.117 4.30807 358.616 4.53516 359.145 4.55927H362.082C361.805 4.54661 361.527 4.59039 361.267 4.68797C361.006 4.78556 360.768 4.93492 360.567 5.12704C360.366 5.31916 360.206 5.55004 360.097 5.80574C359.987 6.06144 359.931 6.33666 359.931 6.61476C359.931 6.89286 359.987 7.16807 360.097 7.42377C360.206 7.67947 360.366 7.91036 360.567 8.10247C360.768 8.29459 361.006 8.44395 361.267 8.54153C361.527 8.63912 361.805 8.6829 362.082 8.67024H357.971C357.694 8.65758 357.416 8.70136 357.156 8.79895C356.895 8.89653 356.657 9.0459 356.456 9.23801C356.255 9.43013 356.095 9.66101 355.986 9.91671C355.876 10.1724 355.82 10.4476 355.82 10.7257C355.82 11.0038 355.876 11.279 355.986 11.5347C356.095 11.7904 356.255 12.0213 356.456 12.2134C356.657 12.4056 356.895 12.5549 357.156 12.6525C357.416 12.7501 357.694 12.7939 357.971 12.7812H381.762C382.291 12.7571 382.79 12.53 383.156 12.1472C383.522 11.7643 383.726 11.2552 383.726 10.7257C383.726 10.1962 383.522 9.68712 383.156 9.30429C382.79 8.92145 382.291 8.69435 381.762 8.67024H385.873C386.151 8.6829 386.428 8.63912 386.689 8.54153C386.949 8.44395 387.187 8.29459 387.388 8.10247C387.589 7.91036 387.749 7.67947 387.859 7.42377C387.968 7.16807 388.024 6.89286 388.024 6.61476C388.024 6.33666 387.968 6.06144 387.859 5.80574C387.749 5.55004 387.589 5.31916 387.388 5.12704C387.187 4.93492 386.949 4.78556 386.689 4.68797C386.428 4.59039 386.151 4.54661 385.873 4.55927Z",
    fill: "#252223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.719 152.055C158.391 152.294 158.211 152.426 158.211 152.426C158.398 152.328 158.569 152.203 158.719 152.055Z",
    fill: "url(#paint0_linear_1_331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.116 152.456C158.788 152.695 158.608 152.827 158.608 152.827C158.795 152.729 158.966 152.604 159.116 152.456Z",
    fill: "url(#paint1_linear_1_331)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M167.629 144.99C167.629 144.99 154.779 163.098 149.699 181.399C149.699 181.399 145.221 189.186 145.806 197.169L137.644 236.695L152.636 242.342C152.636 242.342 151.859 237.476 154.771 234.748C157.682 232.02 164.504 204.375 163.923 200.093C163.923 200.093 173.268 176.729 182.613 167.576C191.957 158.424 196.61 156.315 197.981 148.413C197.989 148.413 176 137.784 167.629 144.99Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M130.375 131.085L130.371 131.087C128.725 131.881 128.034 133.858 128.828 135.504L132.973 144.102C133.767 145.748 135.744 146.439 137.39 145.646L137.394 145.644C139.04 144.85 139.731 142.873 138.937 141.227L134.792 132.629C133.998 130.983 132.021 130.292 130.375 131.085Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.535 132.379C134.718 130.685 132.682 129.973 130.987 130.79C129.292 131.607 128.581 133.643 129.398 135.338L133.458 143.759C134.275 145.454 136.311 146.166 138.006 145.349C139.701 144.532 140.412 142.495 139.595 140.801L135.535 132.379Z",
    fill: "#CBDAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.836 144.778C138.127 144.638 138.212 144.211 138.025 143.825C137.839 143.438 137.452 143.238 137.161 143.379C136.87 143.519 136.785 143.946 136.972 144.333C137.158 144.719 137.545 144.919 137.836 144.778Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_331",
    x1: 421.804,
    y1: 325.265,
    x2: 422.408,
    y2: 325.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_331",
    x1: 422.673,
    y1: 326.012,
    x2: 423.283,
    y2: 326.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 407.682,
    height: 290.5,
    fill: "white",
    transform: "translate(-11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.49715bfc8ee4a2ca34483dc9fed5874f.svg";
export { ForwardRef as ReactComponent };